module.exports = __webpack_public_path__ + "static/img/joinUs_04.ee3477c1.jpg";